// Email code copy: opencode-go/glm-5.3, sessions ses_f0e16c122ffeGy61Fvw46YnF3Z and ses_f0c3d18b4ffe4oXqvq8ZCA6OVS.
// Authored with opencode-go/glm-5.3, session ses_f0e708f2bffetkKkRUMmfNZGfl.
export const signInCopy = {
  confirmTitle: 'Confirm sign in',
  confirmBody: 'Press Sign in below to finish signing in.',
  confirmButton: 'Sign in',
  sentBody: 'We sent an email to {email}. Open the newest one and press Sign in to finish.',
  codeSentBody: "We sent a sign-in email to {email}. Enter the six-digit code below, or open the link in that email.",
  emailHelp: "Password-free. Your email has a code or a link, whichever is easier.",
  codeLabel: "Six-digit code",
  codeButton: "Sign in",
  invalidCode: "Enter the six digits from your email.",
  codeError: "That code didn't work. It may be wrong, expired, or already used. Enter the code from the newest email and try again.",
  codeHint: "Each code works once. Use the code from the newest email.",
}
